import { useState, useMemo, useRef } from "react";
import { BsArrowDownUp } from "react-icons/bs";

const RateTable = ({ currentPosts }) => {
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [columnWidths, setColumnWidths] = useState({
    id: 80,
    userid: 150,
    username: 150,
    projectid: 120,
    activity: 150,
    unit: 100,
    rate: 100,
  });

  const resizingCol = useRef(null);

  // ✅ Sorting logic
  const sortedData = useMemo(() => {
    const sortedArray = [...currentPosts];
    if (sortColumn !== "") {
      sortedArray.sort((a, b) => {
        const valueA = a[sortColumn];
        const valueB = b[sortColumn];
        if (valueA < valueB) return sortDirection === "asc" ? -1 : 1;
        if (valueA > valueB) return sortDirection === "asc" ? 1 : -1;
        return 0;
      });
    }
    return sortedArray;
  }, [currentPosts, sortColumn, sortDirection]);

  const handleSort = (column) => {
    if (column === sortColumn) {
      setSortDirection((prevSortDirection) =>
        prevSortDirection === "asc" ? "desc" : "asc"
      );
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };

  // ✅ Column resizing logic
  const handleMouseDown = (e, col) => {
    e.preventDefault();
    resizingCol.current = { col, startX: e.clientX, startWidth: columnWidths[col] };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleMouseMove = (e) => {
    if (!resizingCol.current) return;
    const { col, startX, startWidth } = resizingCol.current;
    const newWidth = Math.max(50, startWidth + (e.clientX - startX));
    setColumnWidths((prev) => ({ ...prev, [col]: newWidth }));
  };

  const handleMouseUp = () => {
    resizingCol.current = null;
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  };

  // ✅ Reusable Header with Sort + Resizable Border
  const ResizableHeader = ({ colKey, label }) => (
    <th
      style={{
        width: columnWidths[colKey],
        position: "relative",
        userSelect: "none",
      }}
    >
      <div
        className="d-flex flex-row items-center justify-content-center"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort(colKey)}
      >
        <span className="d-flex flex-row items-center">
          <BsArrowDownUp /> <span className="ps-1">{label}</span>
        </span>
      </div>
      {/* Drag border */}
      <div
        onMouseDown={(e) => handleMouseDown(e, colKey)}
        style={{
          cursor: "col-resize",
          position: "absolute",
          right: 0,
          top: 0,
          height: "100%",
          width: "5px",
          zIndex: 5,
        }}
      />
    </th>
  );

  return (
    <div style={{ overflowX: "auto" }}>
      <table className="table table-bordered" style={{ minWidth: "800px", borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <ResizableHeader colKey="id" label="ID" />
            <ResizableHeader colKey="userid" label="Userid" />
            <ResizableHeader colKey="username" label="Username" />
            <ResizableHeader colKey="projectid" label="Projectid" />
            <ResizableHeader colKey="activity" label="Activity" />
            <ResizableHeader colKey="unit" label="Unit" />
            <ResizableHeader colKey="rate" label="Rate" />
          </tr>
        </thead>
        <tbody>
          {sortedData.map((myData, index) => (
            <tr key={index}>
              <td style={{ width: columnWidths.id, fontWeight: "bold" }}>{myData.id}</td>
              <td style={{ width: columnWidths.userid }}>{myData.userid}</td>
              <td style={{ width: columnWidths.username }}>{myData.username}</td>
              <td style={{ width: columnWidths.projectid }}>{myData.projectid}</td>
              <td style={{ width: columnWidths.activity }}>{myData.activity}</td>
              <td style={{ width: columnWidths.unit }}>{myData.unit}</td>
              <td style={{ width: columnWidths.rate }}>{myData.rate}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RateTable;
